import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useSelector } from 'react-redux';
var CheckAuth = function CheckAuth(_ref) {
  var children = _ref.children;
  var userLoggedIn = useSelector(function (_ref2) {
    var user = _ref2.user;
    return user.loggedIn;
  });
  var location = useLocation();
  return userLoggedIn ? children : /*#__PURE__*/React.createElement(Navigate, {
    to: "/login?redirect=".concat(location.pathname).concat(location.search)
  });
};
export default CheckAuth;